import {Injectable} from '@angular/core';
import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ConfirmDialogService} from './services/confirm-dialog-service/confirm-dialog.service';
import {Settings} from './settings/settings';
import {LocalStorage} from './utils/storage';

@Injectable()
export class CodaltInterceptor implements HttpInterceptor {

    static loadingCount = 0;

    constructor(private confirmDialogService: ConfirmDialogService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.indexOf(Settings.API_ENDPOINT) !== -1) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + LocalStorage.userToken,
                    Accept: 'application/json'
                }
            });
        }
        return next.handle(request)
            .pipe(tap((response) => {
                if (response.type === HttpEventType.Sent) {
                    setTimeout(() => {
                        CodaltInterceptor.loadingCount++;
                    });
                }
                if (response.type === HttpEventType.Response) {
                    setTimeout(() => {
                        CodaltInterceptor.loadingCount--;
                    }, 250);
                }
            }, (error) => {
                setTimeout(() => {
                    CodaltInterceptor.loadingCount--;
                });
                if ([500, 422].includes(error.status)) {
                    let errorMessage = '';
                    if (error.error && error.error.message) {
                        errorMessage = error.error.message;
                    }
                    console.error(error, errorMessage);
                    this.confirmDialogService.confirm('Er is een fout opgetreden', errorMessage, 'Sluiten', null);
                }
            }));
    }
}



